// packages
import cx from 'classnames';
import { intcomma } from 'journalize';
import { Fragment, h } from 'preact';

export default function CandidateRow({
  candidate,
  isViewable = true,
  winnerSlug,
}) {
  const rowClass = cx('candidate', 'contest__candidate-row', {
    'contest__candidate-row--winner': winnerSlug === candidate.slug,
    'contest__candidate-row--hidden': !isViewable,
  });

  const hasFirstLastName = Boolean(candidate.first && candidate.last);

  return (
    <tr class={rowClass}>
      <td>
        {hasFirstLastName ? (
          <Fragment>
            <span class="candidate__name candidate__name--first">
              {candidate.first}
            </span>
            <span class="candidate__name candidate__name--last">
              {candidate.last}{' '}
              {candidate.party && (
                <span class="candidate__party">
                  ({candidate.party.slice(0, 1)})
                </span>
              )}
            </span>
          </Fragment>
        ) : (
          <span class="candidate__name candidate__name--last">
            {candidate.name}
          </span>
        )}
      </td>
      <td class="table-align-right">{intcomma(candidate.votes)}</td>
      <td class="table-align-right">
        {candidate.pct}
        <span class="candidate__pct-symbol">%</span>
      </td>
    </tr>
  );
}
